<div class="sync-conv-margin-left">
  <h3 class="crm-sections-title" translate="crm/configuration/agents-workflow"></h3>
  <a
    *ngIf="crmType === 'salesforce'"
    class="crm-doc-links"
    href="https://developers.alcmeon.com/docs/sf-configuration-alcmeon#triggers"
    target="_blank"
    rel="noopener noreferrer">
    {{ 'crm/configuration/sync-conversation-doc' | translate }}
  </a>

  <div class="agent-workflow-section">
    <mat-slide-toggle [formControl]="fromAlcmeonEnabledControl">
      <span translate="crm/configuration/agents-workflow/from-alcmeon"></span>
    </mat-slide-toggle>
    <div class="agents-workflow-description">
      <ng-container [ngSwitch]="crmType">
        <ng-container *ngSwitchCase="'salesforce'">
          <ng-container *ngTemplateOutlet="agentsWorkflowFromAlcmeonToSalesforce"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'zendesk'">
          <ng-container *ngTemplateOutlet="agentsWorkflowFromAlcmeonToZendesk"></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="agent-workflow-section">
    <ng-container [ngSwitch]="crmType">
      <ng-container *ngSwitchCase="'salesforce'">
        <mat-slide-toggle [formControl]="fromCRMEnabledControl">
          <span translate="crm/configuration/agents-workflow/from-sf"></span>
        </mat-slide-toggle>
        <div class="agents-workflow-description">
          <ng-container *ngTemplateOutlet="agentsWorkflowFromSalesforceToAlcmeon"></ng-container>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'zendesk'">
        <mat-slide-toggle [formControl]="fromCRMEnabledControl">
          <span translate="crm/configuration/agents-workflow/from-zendesk"></span>
        </mat-slide-toggle>
        <div class="agents-workflow-description">
          <ng-container *ngTemplateOutlet="agentsWorkflowFromZendeskToAlcmeon"></ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<ng-template #agentsWorkflowFromAlcmeonToSalesforce>
  <div [class.alc-disable-block]="!configuration.agents_workflow.from_alcmeon.enabled" class="sync-conv-margin-left">
    <div>
      {{ 'crm/configuration/agents-workflow/from-alcmeon/description' | translate }}
    </div>
    <div>
      <mat-radio-group [formControl]="fromAlcmeonPushToCrmTriggersControl">
        <mat-radio-button [value]="triggerMsgRepliedByAgentAndUserMatched">
          <strong
            translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-replied-by-agent-and-user-matched-1"></strong>
          <span
            translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-replied-by-agent-and-user-matched-2"></span>
          <strong
            translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-replied-by-agent-and-user-matched-3"></strong>
          <span
            translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-replied-by-agent-and-user-matched-4"></span>
        </mat-radio-button>
        <mat-radio-button [value]="triggerMsgRoutedToCrmTeam">
          <div>
            <strong
              translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-routed-to-crm-team-title"></strong>
            <span
              translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-routed-to-crm-team-description"></span>
          </div>
          <div>
            <span
              class="alc-smaller-text"
              translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-routed-to-crm-team/note"></span>
          </div>
          <div
            (click)="blinkWorkflowTitle('alcmeonToSf')"
            class="agents-workflow-link-with-margin-left"
            translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-routed-to-crm-team/workflow-link"></div>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</ng-template>

<ng-template #agentsWorkflowFromSalesforceToAlcmeon>
  <div [class.alc-disable-block]="!configuration.agents_workflow.from_sf.enabled" class="sync-conv-margin-left">
    <div>
      <span> {{ 'crm/configuration/agents-workflow/from-alcmeon/description' | translate }} </span>
      <div layout="row" class="alc-margin-top-8">
        <strong translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-routed-to-crm-team-title"></strong
        >&nbsp;
        <span
          translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-routed-to-crm-team-description"></span>
      </div>

      <span
        (click)="blinkWorkflowTitle('alcmeonToSf')"
        class="agents-workflow-link"
        translate="crm/configuration/agents-workflow/push_to_crm_triggers/msg-routed-to-crm-team/workflow-link"></span>
    </div>
    <div class="alc-margin-top-16" layout="column">
      <div>{{ 'crm/configuration/agents-workflow/from-sf/description' | translate }}</div>
      <div
        class="alc-margin-top-8 bold"
        [innerHTML]="'crm/configuration/agents-workflow/push-to-alcmeon' | translate"></div>
      <div
        class="agents-workflow-link"
        (click)="blinkWorkflowTitle('sfToAlcmeon')"
        translate="crm/configuration/agents-workflow/push-to-alcmeon/workflow-link"></div>
    </div>
  </div>
</ng-template>

<ng-template #agentsWorkflowFromAlcmeonToZendesk>
  <div [class.alc-disable-block]="!configuration.agents_workflow.from_alcmeon.enabled">
    <div>
      {{ 'crm/configuration/agents-workflow/from-alcmeon-to-zendesk/description' | translate }}
    </div>
    <div>
      <strong
        translate="crm/configuration/agents-workflow/from-alcmeon-to-zendesk/push_to_crm_triggers/msg-replied-by-agent-and-user-matched-1"></strong
      >&nbsp;
      <span
        translate="crm/configuration/agents-workflow/from-alcmeon-to-zendesk/push_to_crm_triggers/msg-replied-by-agent-and-user-matched-2"></span>
    </div>
  </div>
</ng-template>

<ng-template #agentsWorkflowFromZendeskToAlcmeon>
  <div [class.alc-disable-block]="!configuration.agents_workflow.from_sf.enabled">
    <div>{{ 'crm/configuration/agents-workflow/from-zendesk-to-alcmeon/description' | translate }}</div>

    <div class="select-team-description">
      <span
        [innerHTML]="
          'crm/configuration/agents-workflow/from-zendesk-to-alcmeon/push_to_crm_triggers/msg-replied-by-agent-and-user-matched'
            | translate
        "></span>
      &nbsp;
      <app-select
        appearance="outline"
        [control]="zendeskControl.get('teamTagIds')"
        [items]="routingTagsItems"
        [multiple]="true"
        labelKey="crm/configuration/workflow-mappings/from-alcmeon-to-zendesk/select-team-label">
      </app-select>
    </div>
    <div translate="crm/configuration/workflow-mappings/from-zendesk-to-alcmeon/select-custom-fields-description"></div>
    <div class="select-custom-field">
      <app-select
        *ngIf="emailCustomFields?.length"
        appearance="outline"
        [control]="zendeskControl.get('emailCustomField')"
        [items]="emailCustomFields"
        labelKey="crm/configuration/workflow-mappings/from-alcmeon-to-zendesk/select-email-custom-field-label">
      </app-select>
    </div>
    <div class="agents-workflow-link-with-margin-left">
      <a class="custom-fields-links" [href]="customFieldsLink" target="_blank">
        {{ 'crm/configuration/workflow-mappings/from-zendesk-to-alcmeon/custom-fields-links' | translate }}
        &nbsp;<mat-icon>open_in_new</mat-icon>
      </a>
    </div>
  </div>

  <div class="enable-continuous-synchronization">
    <mat-slide-toggle [formControl]="$any(zendeskControl.get('enableContinuousSynchronization'))">
      <span translate="crm/configuration/continuous-synchronization/label"></span>
      <small translate="crm/configuration/continuous-synchronization/hint"></small>
    </mat-slide-toggle>
  </div>
</ng-template>
